var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[(_vm.mini)?_c('div',{staticClass:"col-12 text-center"},[_vm._m(0)]):_c('div',{staticClass:"col-12 text-center"},[_vm._m(1),_c('h5',[_vm._v(_vm._s(_vm.title ? _vm.title : 'Betöltés')+"...")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"fa fa-cog fa-spin"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('i',{staticClass:"fas fa-cog fa-spin"})])
}]

export { render, staticRenderFns }